export const environment = {
    production: false
};

export const API_URL = 'https://grsp-core-srv-dev.azurewebsites.net/api/';
